/**
 * Cognito hosted-UI links on the sign-in page: "Sign in with OMCi" and the
 * previous login's password recovery. Both return to /login_callback, which
 * completes the session and hands over to the Launch Pad resolver (SPEC-007).
 * A page requested before sign-in is carried across the round trip in
 * sessionStorage by utilities/entryRouting.js, so these links never change
 * with the page design.
 *
 * `process.env.NEXT_PUBLIC_*` must be spelled out literally for Next.js to
 * inline it in the browser bundle, hence the two thin wrappers at the bottom.
 */
export const LOGIN_CALLBACK_PATH = "/login_callback";

export function loginCallbackUri(frontendPath) {
    return `${frontendPath}${LOGIN_CALLBACK_PATH}`;
}

/** The hosted-UI query the backend's federated_login endpoint expects: code flow, openid + email. */
export function hostedUiHref(baseUrl, redirectUri) {
    return `${baseUrl}&redirect_uri=${redirectUri}&response_type=code&state=state&scope=openid%20email`;
}

export function signInWithOmciHref() {
    return hostedUiHref(process.env.NEXT_PUBLIC_FEDERATED_LOGIN_URL, loginCallbackUri(process.env.NEXT_PUBLIC_FRONTEND_PATH));
}

export function forgotPasswordHref() {
    return hostedUiHref(process.env.NEXT_PUBLIC_FEDERATED_FORGOT_PASSWORD_URL, loginCallbackUri(process.env.NEXT_PUBLIC_FRONTEND_PATH));
}
